<script lang="ts">
    //export let rating
    import Stars from "./Stars.svelte"
    export let rating: OrderRating
    export let nr
    export let ratingsShown
</script>

{#if rating.comment}
    <div class="rating-block" class:hidden="{nr + 1 > ratingsShown}">
        <Stars stars="{rating.rating}" identifier="justdoit" />
        <div class="name">{rating.author}</div>
        <div class="rating">
            {@html rating.comment}
        </div>
    </div>
{/if}

<style lang="less">
    .hidden {
        display: none !important;
    }
    .rating-block {
        display: flex;
        width: 100%;
        flex-direction: column;
        overflow: hidden;
        padding-bottom: 20px;
        border-bottom: 1px dotted #c7c7c7;
        font-size: 0.9rem;
        .name {
            font-weight: bold;
            margin-top: 10px;
            color: black;
            font-stretch: condensed;
        }
    }
</style>
